import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback } from 'react';
import { InvoiceContext } from 'src/sections/invoice_details/InvoiceDetailsContext';
import { useContextSelector } from 'use-context-selector';
import GridCellBase from '../GridCellBase';
import ExpandCollapseCell from './ExpandCollapseCell';

const DetailColumnCell = (props: GridCellProps) => {
  let { expanded = false } = props.dataItem;
  const { dataItem } = props;
  const { receiptLineItemId = 0 } = dataItem;
  const setExpandedLineItemIds = useContextSelector(
    InvoiceContext,
    (value) => value.setExpandedLineItemIds
  );
  const expandedLineItemIds = useContextSelector(
    InvoiceContext,
    (value) => value.expandedLineItemIds
  );
  const handleExpandClick = useCallback(() => {
    if (expandedLineItemIds.includes(receiptLineItemId)) {
      const updatedItems = expandedLineItemIds.filter((item) => item !== receiptLineItemId);
      setExpandedLineItemIds(updatedItems);
    } else {
      setExpandedLineItemIds((prev) => [...prev, receiptLineItemId]);
    }
  }, [expandedLineItemIds, receiptLineItemId, setExpandedLineItemIds]);

  return (
    <GridCellBase {...props} className="k-hierarchy-cell" disableToolTip>
      <ExpandCollapseCell
        title="Expand/Collapse"
        expand={expanded}
        onExpand={handleExpandClick}
        plusIconColor="#0e80b4"
        minusIconColor="#0e80b4"
      />
    </GridCellBase>
  );
};

export default DetailColumnCell;
